// extracted by mini-css-extract-plugin
export default {"pageSizeSelector":"Pagination_pageSizeSelector__ZEJzj","pageSize":"Pagination_pageSize__SVwS6"};